import React from 'react';
import { X, Check } from 'lucide-react';
import { whyWeDoItThisWay } from '../../data/mock';

const WhyWeDoItSection = () => {
  return (
    <section className="bg-black text-white">
      {/* Header */}
      <div className="px-6 lg:px-12 xl:px-20 py-16 lg:py-24 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium leading-tight max-w-3xl mx-auto">
          {whyWeDoItThisWay.title}
        </h2>
      </div>

      {/* Comparison Grid */}
      <div className="grid lg:grid-cols-2">
        {/* Most Platforms - Dark */}
        <div className="bg-white/5 p-10 lg:p-16">
          <h3 className="text-xl font-medium text-white/60 mb-8">
            {whyWeDoItThisWay.mostPlatforms.title}
          </h3>
          <div className="space-y-5">
            {whyWeDoItThisWay.mostPlatforms.items.map((item, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="w-6 h-6 bg-red-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <X className="w-4 h-4 text-red-400" />
                </div>
                <span className="text-white/70">{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Our Approach - Accent Green */}
        <div className="bg-accent-green text-black p-10 lg:p-16">
          <h3 className="text-xl font-medium text-black/70 mb-8">
            {whyWeDoItThisWay.ourApproach.title}
          </h3>
          <div className="space-y-5">
            {whyWeDoItThisWay.ourApproach.items.map((item, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="w-6 h-6 bg-black/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-4 h-4 text-black" />
                </div>
                <span className="text-black/90 font-medium">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Tagline */}
      <div className="px-6 lg:px-12 xl:px-20 py-16 lg:py-24 text-center">
        <p className="text-2xl md:text-3xl lg:text-4xl font-medium text-accent-green">
          {whyWeDoItThisWay.conclusion}
        </p>
      </div>
    </section>
  );
};

export default WhyWeDoItSection;
